import React from 'react';
import { styled } from '@compiled/react';
import Icon from '@atlaskit/icon';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

export const PulseGlyph = () => (
	<svg
		width={gridSize * 2}
		height={gridSize * 2}
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M2 8.70457H5.81067L7.7095 4L8.7403 12L10.5306 7.07724H14"
			stroke={token('color.icon.subtle')}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const PulseIcon = () => (
	<IconWrapper>
		<Icon glyph={PulseGlyph} size="medium" label="" />
	</IconWrapper>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IconWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
});
